import type { CatalogRatioShortData, CatalogRatioData } from '@gql/graphql';

import { Checkbox } from '@consta/uikit/Checkbox';
import { useEffect, useMemo, useState } from 'react';

import Styles from '../../massRatioApplication.module.css';

interface UpdateBaseCostRatioRowData extends CatalogRatioData {
    groupRow?: boolean;
}

interface ICoefficientRenderCheckbox {
    checkedIds: Record<string, CatalogRatioShortData | null>;
    data: UpdateBaseCostRatioRowData;
    handleChangeCheckbox: (row: CatalogRatioData) => ({ checked }: { checked: boolean }) => void;
    currentRowData: CatalogRatioData[] | null;
    canCheckGroupRow: boolean;
    canCheckRow: boolean;
}

export const BaseCostsTableCellRenderCheckbox = (props: ICoefficientRenderCheckbox) => {
    const { checkedIds, data, handleChangeCheckbox, currentRowData, canCheckGroupRow, canCheckRow } = props;

    const [checkedAll, setCheckedAll] = useState<boolean>(false);

    const trueValuesByGroupLength = useMemo(
        () =>
            Object.values(checkedIds).filter(
                (value) => !!value && currentRowData?.some((baseCost) => baseCost.id === value.id),
            ).length,
        [checkedIds, currentRowData],
    );

    useEffect(() => {
        setCheckedAll(currentRowData?.length === trueValuesByGroupLength);
    }, [currentRowData?.length, trueValuesByGroupLength]);

    const intermediate = trueValuesByGroupLength > 0 && trueValuesByGroupLength !== currentRowData?.length;

    const headRows = !!data?.groupRow;
    const currentChecked = headRows ? checkedAll : !!checkedIds[data?.id];
    const currentChange = headRows ? undefined : handleChangeCheckbox(data);
    const currentIntermediate = headRows ? intermediate : false;

    const currentDisabled = (() => (headRows ? !canCheckGroupRow : !canCheckRow))();

    return (
        <div className="CheckboxWrapper">
            <Checkbox
                className={Styles.checkboxFocus}
                checked={currentChecked}
                onChange={currentChange}
                disabled={currentDisabled}
                intermediate={currentIntermediate}
            />
        </div>
    );
};

BaseCostsTableCellRenderCheckbox.displayName = 'BaseCostsTableCellRenderCheckbox';
